import { render } from "./Games_GameInner.vue?vue&type=template&id=533e1817"
import script from "./Games_GameInner.vue?vue&type=script&lang=js"
export * from "./Games_GameInner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__